import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject, combineLatest, merge, of, Subject } from 'rxjs';
import { map, scan, tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { WidgetNotificacionService } from './widget-notificacion.service';
import { CustomAlertService } from '../custom-alert/custom-alert.service';

@Component({
  templateUrl: 'widget-notificacion.component.html',
  standalone: false,
  styleUrls: ['widget-notificacion.component.scss']
})

export class WidgetNotificacionComponent implements OnInit {

  widgetTitle = this.data && this.data.widgetTitle ? this.data.widgetTitle : 'Notificar';
  fromListTitle = this.data && this.data.fromListTitle ? this.data.fromListTitle : 'Citados';
  toListTitle = this.data && this.data.toListTitle ? this.data.toListTitle : 'Notificar';

  showComment = this.data && this.data.showComment;
  commentCtrl = new UntypedFormControl('');

  originalList$ = of(this.data && this.data.fromList ? this.data.fromList : []);

  private fromListInsertedSubject = new Subject<{ op: string, value: any }>();
  fromListIOAction$ = this.fromListInsertedSubject.asObservable();
  fromListWithActions$ = merge(
    this.originalList$,
    this.fromListIOAction$
  )
    .pipe(
      scan((acc, value) => {
        if (value.op === 'remove') {
          return acc.filter(teacherI => teacherI.id !== value.person.id);
        }
        if (value.op === 'add') {
          return [...acc, value.person];
        }
      })
    );

  private filterInputSubject = new BehaviorSubject<string>('');
  filterInputAction$ = this.filterInputSubject.asObservable();
  allSelectedCtrl = false;
  fromList$ = combineLatest([
    this.fromListWithActions$,
    this.filterInputAction$
  ]).pipe(
    map(([fromList, filterValue]) => {
      const list = fromList.filter(fromItem => fromItem.apellidosNombres.toLowerCase().indexOf(filterValue) > -1);
      return list;
    })
  );

  allRemoveCtrl = false;
  toList$ = of([]);
  private toListInsertedSubject = new Subject<any>();
  toListInsertedAction$ = this.toListInsertedSubject.asObservable();
  toListWithActions$ = merge(
    this.toList$,
    this.toListInsertedAction$
  )
    .pipe(
      scan((acc, value) => {
        if (value.op === 'remove') {
          return acc.filter(teacherI => teacherI.id !== value.person.id);
        }
        if (value.op === 'add') {
          return [...acc, value.person];
        }
      })
    );

  allData$ = combineLatest([
    this.fromList$,
    this.toListWithActions$
  ])
    .pipe(
      map(([fromList, toList]) => {
        return { fromList, toList };
      })
    );

  constructor(public dialogRef: MatDialogRef<WidgetNotificacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private _snackBar: MatSnackBar,
    private noticacionesService: WidgetNotificacionService,
    private customAlertService: CustomAlertService) {
  }

  ngOnInit() {
  }

  selectedPersonStatus(person, checked) {
    person['isSelected'] = checked;
  }

  addSelection(list) {
    list.map(person => {
      if (person.isSelected) {
        this.addToNotifyList(person);
      }
    });
    this.allSelectedCtrl = false;
  }

  removeSelection(list) {
    list.map(person => {
      if (person.isSelected) {
        this.removeFromNotifyList(person);
      }
    });
    this.allRemoveCtrl = false;
  }

  addToNotifyList(person) {
    this.toListInsertedSubject.next({ op: 'add', person });
    // @ts-ignore
    this.fromListInsertedSubject.next({ op: 'remove', person });
  }

  removeFromNotifyList(person) {
    // @ts-ignore
    this.fromListInsertedSubject.next({ op: 'add', person });
    this.toListInsertedSubject.next({ op: 'remove', person });
  }

  filter(value: string) {
    this.filterInputSubject.next(value.toLowerCase());
  }

  selectAllToAdd(list) {
    this.allSelectedCtrl = !this.allSelectedCtrl;
    list.map(person => person['isSelected'] = this.allSelectedCtrl);
  }

  selectAllToRemove(list) {
    this.allRemoveCtrl = !this.allRemoveCtrl;
    list.map(person => person.isSelected = this.allRemoveCtrl);
  }

  notify(list) {
    const model = {
      fecha: this.data.modelData.fecha,
      detalle: this.commentCtrl.value,
      tipoOrigen: this.data.modelData.tipoOrigen,
      personas: list
    };
    this.noticacionesService.notify(model).subscribe(
      res => {
        this._snackBar.open(`Notificación satisfactoria`, null, {duration: 2500});
        this.dialogRef.close();
      },
      err => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la notificación. <br> Código de error: ${err.statusText}`
        });
      },
      () => { }
    );
  }
}
